module.exports = __webpack_public_path__ + "static/media/processing-icon.5d77637c.svg";